<template>
   <div id="accessories">
      <!-- <el-tabs v-model="partsPageDto.partsCateId" @tab-click="handleClick">
        <el-tab-pane
        v-for="item in tabList"
        :key="item.partCateId"
        :label="item.cateName"
        :name="item.partCateId"
      >
      </el-tab-pane>
     </el-tabs> -->
       <div class="tos">
          <el-form :inline="true" :model="partsPageDto" label-width="100px"  class="demo-form-inline">
             <el-form-item label="关键字：">
                <el-input v-model="partsPageDto.keyWord"></el-input>
             </el-form-item>
             <el-form-item label="配件分类：">
               <el-select v-model="partsPageDto.partsCateId" clearable placeholder="请选择配件分类">
                     <el-option
                        v-for="item in ydyoptions"
                        :key="item.cateId"
                        :label="item.cateName"
                        :value="item.cateId">
                     </el-option>
                  </el-select>
             </el-form-item>
             <el-form-item>
                <el-button type="primary" @click="sjhsearchFor(partsPageDto.keyWord)" plain>查询</el-button>
             </el-form-item>
          </el-form>
          <el-button class="left_item"  type="primary" @click=newoks()>添加配件</el-button>
       </div>
       <div class="tjannos">
          <!-- <div class="right-item">
            <el-button  type="primary" @click=tjggnewoks() plain>添加配件类型</el-button>
            <el-button  type="warning" @click=newoktypes() plain>编辑配件类型</el-button>
          </div> -->
       </div>
       <div class="tableform">
         <el-table
             :data="tableData"
             border
             stripe
             :cell-style="{'text-align':'center'}"
             :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
             style="width: 100%">
             <el-table-column
                prop="partsName"
                label="配件名称"
                >
                <template slot-scope="{row:{ partsName }}">
                {{ partsName|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="partDetailVariantsVos"
                label="配件规格"
                show-overflow-tooltip
                >
                <template slot-scope="scope">
                     <span v-for="(item, index) in scope.row.partDetailVariantsVos" :key="index">
                     <span>{{ item.specSku }}，</span>
                  </span>
                </template>
             </el-table-column>
             <el-table-column
                prop="imageUrl"
                label="配件图片"
                >
                <template slot-scope="scope">
                  <img :src="scope.row.imageUrl" class="image-column" @click="handlePreview(scope.row)" />
               </template>
             </el-table-column>
             <el-table-column
                prop="partsRange"
                label="范围"
                >
                <template slot-scope="{row:{ partsRange }}">
                {{ partsRange|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="partsDesc"
                label="配件描述"
                show-overflow-tooltip
                >
                <template slot-scope="{row:{ partsDesc }}">
                {{ partsDesc|| "—" }}
                </template>
             </el-table-column>
             <el-table-column
                prop="remark"
                label="备注"
                >
                <template slot-scope="{row:{ remark }}">
                {{ remark|| "—" }}
                </template>
             </el-table-column>
             <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                     <i title="编辑" class="el-icon-alixiugai" style="color: #1296db;cursor: pointer;"  @click=bianjiClick(scope.row) ></i>
                     <i title="下架" class="el-icon-alixiajia" style="color: #52C891;cursor: pointer;" @click =removefrom(scope.row)></i>
                     <i title="删除"  class="el-icon-alishanchu" style="color: #d81e06;cursor: pointer;"  @click=dels(scope.row) ></i>
                </template>
             </el-table-column>
          </el-table>
          <div class="btnbox">
             <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="partsPageDto.pageNum"
                :page-sizes="[10, 15, 20]"
                :page-size="partsPageDto.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="this.totals">
             </el-pagination>
          </div>
       </div>
      <!-- 添加类型 -->
      <el-dialog title="添加配件类型" :visible.sync="tjlxincrease" width="22%" class="zcyhtk" >
      <el-form ref="partsCateAddDto" :model="partsCateAddDto" :rules="rules" label-width="80px" label-position="right" size="small">
         <el-form-item label="测报类型:" prop="cateParentId">
               <el-select v-model="partsCateAddDto.cateParentId" clearable placeholder="请选择测报类型">
                  <el-option
                     v-for="item in yhlxoptions"
                     :key="item.cateId"
                     :label="item.name"
                     :value="item.cateId">
                  </el-option>
               </el-select>
            </el-form-item>   
         <el-form-item label="配件名称:" prop="cateName">
               <el-input v-model="partsCateAddDto.cateName" placeholder="请输入配件名称"></el-input>
            </el-form-item>
            <el-form-item label="备注信息:">
               <el-input v-model="partsCateAddDto.remark" placeholder="请输入备注信息"></el-input>
            </el-form-item>
      </el-form>
      <div slot="footer">
            <el-button @click="tjlxincrease = false">取 消</el-button>
            <el-button type="primary"  @click="ggtjsubmitForm('partsCateAddDto',partsCateAddDto)">确 定</el-button>
      </div>
      </el-dialog>
         <!-- 编辑配件类型 -->
      <el-dialog title="编辑配件类型" :visible.sync="increasetypes" width="32%"  >
      <div class="tableform">
         <el-table
            :data="gglxdata"
            border
            stripe
            :cell-style="{'text-align':'center', 'cursor': 'pointer'}"
            :header-cell-style="{'background-color': '#eef1f6','text-align':'center'}"
            style="width: 100%"
            >
            <el-table-column
            prop="cateName"
            label="规格名称"
            >
            <template slot-scope="{ row: { cateName } }">
               {{ cateName|| "—" }}
            </template>
            </el-table-column>
            <el-table-column
            prop="remark"
            label="备注信息">
            <template slot-scope="{ row: { remark } }">
               {{ remark|| "—" }}
            </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="80">
               <template slot-scope="scope">
                  <el-button type="text" size="small" style="color: #FF2626;" @click="fwlxdels(scope.row)">删除</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>
      </el-dialog>
              <!-- 大图查看弹窗 -->
      <el-dialog
         v-model="dialogVisible" title="查看大图" :visible.sync="dialogVisible" width="30%"
      >
         <img :src="previewImage" alt="大图" style="width: 100%;" />
      </el-dialog>
   </div>
   </template>
   <script>
import ipConfig from "../../utils/ipconfig";
      export default {
      name:'accessories',
      data(){
       return{
         partsPageDto:{
            pageNum:1,
            pageSize:10,
            keyWord:null,
            partsCateId:null,
         },
          tableData: [],
          totals:10,
          increase:false,
         partsCateAddDto:{
            remark:null,
            cateName:null,
            partsCateId:null,
            cateParentId:null,
         },
         tabList: [],
         yhlxoptions: [],
         ydyoptions:[],
         categoryPageDto:{
          cateType:1,
          parentCateId:null,
          cateName:null,
        },
         tjlxincrease:false,
         increasetypes:false,
         rules: {
            cateName: [
            { required: true, message: '请输入配件名称', trigger: 'change' }
            ],
            cateParentId: [
               { required: true, message: '请选择测报类型', trigger: 'change' }
            ]
         },
         gglxdata:[],
         dialogVisible: false,
         previewImage: '', // 用于存储点击图片后展示的大图 URL
       }
      },
      created(){
         this.partsPageDto.partsCateId = this.$route.query.cateId
         this.cpflgetlist(this.categoryPageDto)
      },
      mounted(){
       this.getlist(this.partsPageDto)
      },
      methods:{
      sjhsearchFor(type){
         this.partsPageDto.keyWord = type
         this.getlist(this.partsPageDto)
      },
      newoks() {
         this.$router.push({
            path: "addaccessories",
            // query: {
            //    partsCateId: this.partsPageDto.partsCateId,
            // },
         });
      },
      cpflgetlist(categoryPageDto) {
          this.$api.cplbbfyqueryList(categoryPageDto)
          .then((res) => {
                if (res.data.code == 200) {
                  this.ydyoptions = res.data.data
               } else {
               this.$message.error(res.data.message)
               }
          })
       },
      bianjiClick(e) {
         this.$router.push({
            path: "adetailsaccessories",
            query: {
               partsId: e.partsId,
            },
         });
      },
      removefrom(row) {
         this.$confirm('是否确认下架?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
               this.$api.downParts({
                  partsId:row.partsId
               }).then((res) => {
                     if(res.data.code==200){
                        this.$message.success(res.data.message)
                        this.getlist(this.partsPageDto)
                     }else{
                        this.$message.error(res.data.message)
                     }
               })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
           
      },
      closeDialog(){
        this.xgtkdfdqx()
      },
      getlist(partsPageDto) {
          this.$api.queryPartsPage(partsPageDto)
          .then((res) => {
            if(res.data.code==200){
               let data = res.data.data.records
               data.forEach(element => {
                  if (element.partsMedias.length>0) { 
                     if (element.partsMedias[0].imageUrl.startsWith('https')) {
                        element.imageUrl = element.partsMedias[0].imageUrl
                     } else {
                        element.imageUrl = ipConfig.baseUrl+element.partsMedias[0].imageUrl
                     }
                  }
               });
               this.tableData  = data
               this.totals = res.data.data.total
            }else{
               this.$message.error(res.data.message)
            }
          })
       },
      newoktypes(){
         this.increasetypes = true
         // this.dataService()
      },
      handlePreview(row) {
         this.previewImage = row.imageUrl;
         this.dialogVisible = true;
      },
      // handleClick(tab, event) {
      //    this.partsPageDto.partsCateId = tab.name
      //    this.getlist(this.partsPageDto)
      // },
      tjggnewoks(){
         this.tjlxincrease = true
      },
      ggtjsubmitForm(formName,data) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$api.operatorPartsCate({
                  cateName:data.cateName,
                  remark:data.remark,
                  cateParentId:data.cateParentId
                }).then((res) => {
                if (res.data.code == 200) {
                    this.tjlxincrease = false
                    this.partsCateAddDto={
                        remark:null,
                        cateName:null,
                        partsCateId:null,
                        cateParentId:null,
                    }
                    this.dataService()
                    this.$message.success(res.data.message)
                } else {
                  this.$message.error(res.data.message)
                }
              })
            } 
          });
      },
      xgtkdfdqx(){
      },
      fwlxdels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.deletePartCate({
               partCateId:e.partCateId
                }).then((res) => {
                  if(res.data.code==200){
                     this.increasetypes = false
                     this.$message.success(res.data.message)
                     this.dataService()
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
        dels(e) {
          this.$confirm('是否确认删除?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$api.deleteParts({
               partId:e.partsId
                }).then((res) => {
                  if(res.data.code==200){
                     this.getlist(this.partsPageDto)
                     this.$message.success(res.data.message)
                  }else{
                     this.$message.error(res.data.message)
                  }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              });          
            });
        },
      handleCurrentChange(val) {
      this.partsPageDto.pageNum = val
      this.getlist(this.partsPageDto)
      },
      handleSizeChange(val) {
         this.partsPageDto.pageSize = val
         this.getlist(this.partsPageDto)
      },
      }
      }
   </script>
   <style scoped>
#accessories {
   width: 100%;
   height: 100%;
   overflow-y: auto;
   background-color: #fff;
   padding:0 0 0 30px;
   box-sizing: border-box;
}
.tos {
   display: flex;
   /* justify-content: space-between; */
   align-items: center;
   /* background: yellow; */
   margin-bottom: 20px;
   margin-left: -30px;
 }
 .elrow{
   box-sizing: border-box;
   width: 20%;
   margin-top: -6px;
   margin: 0 40px 0 20px;
 }
 .elrowleft{
   width: 80%;
   float: left;
   box-sizing: border-box;
 }
 .elrowleft input{
   border: 2px solid #1b93ed !important;
   border-radius: 0 !important;
   width: 100%;
   -webkit-appearance: none;
   appearance: none;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #929da5;
   box-sizing: border-box;
   color: #1f3d35;
   font-size: 14px;
   height: 36px;
   line-height: 1;
   outline: none;
   padding: 3px 10px;
   transition: border-color .2s cubic-bezier(.645,.045,.355,1);
 }
 .elrowcontent{
   width: 16.66667%;
   float: left;
   box-sizing: border-box;
 }
 .search-btn {
   height: 36px;
   width: 100px;
   background: #1b93ed;
   border: 2px solid #1b93ed;
   margin: 0;
   padding: 0;
   color: #fff;
   cursor: pointer;
 }
 .left_item{
   margin-left: auto;
 }
 .right-item {
   margin-left: auto; /* Pushes the item to the right */
 }
 .tos /deep/ .el-form-item {
     margin-bottom: 0 !important;
 }
 .btnbox {
       /* background: pink; */
       display: flex;
       width: 40%;
       align-items: center;
       justify-content: space-around;
       margin: auto;
       margin-top: 30px;
   }
.tjannos{
   display: flex;
   margin-bottom: 20px;
 }
 .zcyhtk /deep/ .el-form-item__label {
    width: 90px !important;
  }
  .zcyhtk /deep/ .el-form-item__content {
    margin-left: 90px !important;
  }
  .image-column {
  width: 50px; /* 控制图片宽度 */
  height: 50px; /* 控制图片高度 */
  object-fit: cover; /* 保持图片比例填充 */
  cursor: pointer;
}
   </style>


// WEBPACK FOOTER //
// src/components/accessorieslist/accessories.vue